// src/utils/paths.js

 const USER_PATHS = {
  HOME: '/',
  PRODUCTS: '/products/:id',
  REVIEWWRITE: '/profile/review/:orderId/:productId',
  SEARCH: '/search/:id',
  CATEGORY: '/category/:slug',
  CAMPAIGN: '/campaign/:slug',
  CATEGORIES: '/categories',
  ABOUT: '/about',
  CONTACT: '/contact',
  CART: '/cart',
  ORDER_DETAILS: '/order/:id',
  CHECKOUT: '/checkout',
  SHIPPING: '/shipping-address',
  REVIEWORDER: '/review-order',
  SUCCESSORDER: '/success-order',
  PAYMENT_RETURN: '/payment/return',
  PAYSTATION_RETURN: '/payment/paystation/return',
  LOGIN: '/login',
  REGISTER: '/register',
  FORGOT_PASSWORD: '/forgot-password',
  PROFILE: '/profile',
  MANAGEPROFILE: '/profile/manage-account',
  ORDER: '/profile/order',
  ORDER_TRACING: '/profile/order/tracing/:trackingId',
  RETURN_AND_REFUND: '/profile/return-and-refund',
  MY_REVIEWS: '/profile/my-reviews',
  WISHLIST_AND_FOLLOWED_STORES: '/profile/wishlist-and-followed-stores',
  APPEAL_DISPUTE_CENTER: '/profile/appeal-dispute-center',
  VAUCHERS: "/profile/vauchers",
  ADDRESS: "/profile/address",
  PAYMENT: "/profile/payment",
  SETTINGS: '/profile/settings', 
	  TERMS_OF_SERVICE: '/terms-of-service',
	  PRIVACY_POLICY: '/privacy-policy',
	  ACCOUNT_DELETION: '/account-deletion',
	  COOKIES_POLICY: '/cookies-policy',
  HELP_CENTER: '/help',
  TRACK_ORDER: '/track-order',
  RETURNS_REFUNDS: '/returns',
  SHIPPING_INFO: '/shipping',
  NOTIFICATIONS: '/profile/notifications',
  VERIFY_EMAIL: '/verify-email',
  COMPLETE_SOCIAL_CLAIM: '/complete-social-claim',
};

export default USER_PATHS;
